angular.module('admin.directives')

.directive('addEditUser', ['UserService', 'HomeService', 'HelperService', 'AgentService', 'FEATURES',
function(UserService, HomeService, helpers, AgentService, FEATURES){
  return {
    restrict: 'E',
    controllerAs: 'addEditUserCtrl',
    bindToController: {
      agentId: '=?',
      homeId: '=?',
      mode: '@',
      onSaved: '&',
      onCancel: '&',
      onDelete: '&',
      showDelete: '=',
      showHomes: '=?',
      showSharedToggle: '=?',
      languageOptionsEnabled: '=?',
      user: '=?',
    },
    scope: {},
    templateUrl: '/admin/templates/partials/add-edit-user.html',

    controller: function(){
      let ctrl = this;

      ctrl.submit = function(){
        ctrl.successful = null;
        ctrl.error = null;

        if(ctrl.mode === 'edit')
          ctrl.save();
        else
          ctrl.add();
      };

      ctrl.add = function(){
        let user = parseForSaving(ctrl.user);
        ctrl.saving = true;

        if(!ctrl.homeId){
          ctrl.error = 'There was an error adding this user.';
          return;
        }

        HomeService.addUserToHome(ctrl.homeId, ctrl.user)
          .then(success)
          .catch(error);
      };

      ctrl.save = function(){
        let user = parseForSaving(ctrl.user);
        ctrl.saving = true;

        UserService.save(user, ctrl.user.id)
          .then(success)
          .catch(error);
      };

      ctrl.deleteUser = function(){
        if(!confirm('Are you sure you want to remove ' + ctrl.user.first_name + ' ' + ctrl.user.last_name + '?'))
          return;

        ctrl.saving = true;
        ctrl.error = '';

        UserService.remove(ctrl.user.id)
          .then(() => {
            ctrl.successful = true;
            ctrl.error = null;
            ctrl.saving = false;
            ctrl.onDelete();
          })
          .catch(error);
      };

      function success(user){
        ctrl.successful = true;
        ctrl.error = null;
        ctrl.saving = false;
        ctrl.resetAdd();
        ctrl.onSaved();
      };

      function error(err){
        ctrl.error = err;
        ctrl.saving = false;
      };

      function parseForSaving(user){
        let userForSave = {
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          mobile: helpers.formatPhone(user.mobile),
          locale: user.locale,
        };

        if(ctrl.agentId)
          userForSave.agentId = ctrl.agentId;

        return userForSave;
      };

      ctrl.resetAdd = function(){
        if(ctrl.mode === 'edit') return;

        ctrl.user = {};
      };

      ctrl.resetAdd();
    }
  }
}]);
